import React, { useState, useEffect } from "react";
import { Modal } from "rsuite";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import GeneralInformation from "./general-info";
import FullVendorList from "./full-vendor-list";
import UnmatchedVendors from "./unmatched-vendors";
import MatchedVendors from "./matched-vendors";
import QAList from "./qaList";
import VendorExportModal from "../../AssignVendorComponent/modals/export-modal";
import CreateMasterModal from "../../AssignVendorComponent/modals/create-master";
import SearchModal from "./search-modal";
import ContextMenu from "../../CommonComponents/ContextMenu";
import { toast } from "../../CommonComponents/ToastComponent/toast";
import {
  getListDataById,
  matchListSupplierToSupplier,
  getQaListVendorsByListId,
  getListSuppliers,
  createChildForListSupplier,
  getSuppliersDataByIds,
  removeMatchedSupplierForListSupplier,
  deleteListSupplier,
  getAllContactsByIds,
  getListSupplierCountByListId,
} from "../../../redux/actions/vendor";
import {
  getExportListReportData,
  getListMatchedVendorData,
} from "../../../services/exportListReport";
import LoaderComponent from "../../CommonComponents/LoaderComponent";
import CreateMastersModal from "./createMastersModal";
import RerunModal from "./rerunModal";
import ModalComponent from "../../CommonComponents/Modal";
import {
  checkIsAdminOrModerator,
  getChunkSizes,
  getContactEmailValue,
  getContactPhoneValue,
} from "../../../services/helper";
import ReportDownloadModal from "./reportDownloadModal";

const ListInfoModal = ({ show, onClose, selectedCompany }) => {
  const tabs = [
    { label: "General Information", value: "general" },
    { label: "Full Supplier List", value: "full" },
    { label: "Unmatched Suppliers", value: "unmatched" },
    { label: "Matched Suppliers", value: "matched" },
  ];

  const unmatchedVendorsColumns = [
    { label: "Supplier Name", name: "suppliername" },
    { label: "Address", name: "address1" },
    { label: "City", name: "city" },
    { label: "State", name: "state" },
    { label: "Zip", name: "zip" },
    { label: "Email", name: "email" },
    { label: "Phone", name: "phone" },
    { label: "Url", name: "url" },
    { label: "Spend", name: "spend" },
    { label: "Partner Supplier Id", name: "partnerSupplierId" },
    { label: "Account Number", name: "accountNumber" },
    { label: "Status", name: "matchStatus" },
  ];

  const vendorListColumns = [
    { label: "Match Status", name: "matchStatus" },
    { label: "QA Status", name: "qaStatus" },
    { label: "Supplier Name", name: "suppliername" },
    { label: "Address", name: "address1" },
    { label: "City", name: "city" },
    { label: "State", name: "state" },
    { label: "Zip", name: "zip" },
  ];

  const matchedVendorsColumns = [
    { label: "Match Score", name: "matchScore" },
    { label: "Supplier Name", name: "suppliername" },
    { label: "Address", name: "address1" },
    { label: "City", name: "city" },
    { label: "State", name: "state" },
    { label: "Zip", name: "zip" },
    { label: "Partner Supplier Id", name: "partnerSupplierId" },
    { label: "Account Number", name: "accountNumber" },
    { label: "Matched Supplier", name: "matchedVendor" },
    { label: "Master Supplier Name", name: "masterSupplierName" },
    { label: "Acceptance Type", name: "acceptanceType" },
  ];

  const listTableColumns = [
    { name: "totalListSuppliers", label: "Total Vendors" },
    { name: "totalMatchedListSuppliers", label: "Suppliers Matched" },
    { name: "totalQaListSuppliers", label: "Suppliers in QA" },
    { name: "totalApSpend", label: "Total AP Spend" },
    { name: "totalCardableSpend", label: "Cardable Spend" },
    { name: "dateSubmitted", label: "Date Imported" },
    { name: "estimatedCompletionDate", label: "Estimated Completion Date" },
  ];

  const createMastersColumns = [
    { label: "Supplier Name", name: "suppliername" },
    { label: "Address", name: "address1" },
    { label: "City", name: "city" },
    { label: "State", name: "state" },
    { label: "Zip", name: "zip" },
    { label: "Card Acceptance", name: "isAcceptCardAcceptance" },
    { label: "ACH Acceptance", name: "isAcceptAchPayments" },
    { label: "Check Acceptance", name: "isAcceptCheckPayments" },
  ];

  const store = useStore().getState();
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    app: {
      listExportColumns,
      supplierMatchColumns,
      paymentOptimizationColumns,
      rwConfigurationColumns,
    },
  } = store;

  const { domain } = store;
  const { currentDomain } = domain;
  const isAdminOrModerator = checkIsAdminOrModerator(currentDomain);

  const [currentTab, setCurrentTab] = useState("general");
  const [generalInfoData, setGeneralInfoData] = useState([]);
  const [showQaListModal, setShowQaListModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showCreateMasterModal, setShowCreateMasterModal] = useState(false);
  const [showSearchOptions, setShowSearchOptions] = useState(false);
  const [showCreateMastersModal, setShowCreateMastersModal] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [exportFileName, setExportFileName] = useState("");
  const [selectedOption, setSelectedOption] = useState("supplierMatch");
  const [fullVendorList, setFullVendorList] = useState([]);
  const [fullVendorPage, setFullVendorPage] = useState(1);
  const [totalFullVendors, setTotalFullVendors] = useState(0);
  const [matchedVendorsData, setMatchedVendorsData] = useState([]);
  const [matchedVendorPage, setMatchedVendorPage] = useState(1);

  const [totalMatchedVendors, setTotalMatchedVendors] = useState(0);
  const [unmatchedVendorsData, setUnmatchedVendorsData] = useState([]);
  const [unmatchedVendorPage, setUnmatchedVendorPage] = useState(1);

  const [totalUnmatchedVendors, setTotalUnmatchedVendors] = useState(0);
  const [qaListVendors, setQaListVendors] = useState([]);
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState([]);
  const [contextMenuElement, setContextMenuElement] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isRefreshListsData, setIsRefreshListsData] = useState(false);
  const [isLoadingListData, setIsLoadingListData] = useState(false);
  const [unmatchedVendorsPage, setUnmatchedVendorsPage] = useState(1);
  const [unmatchedVendorsLimit, setUnmatchedVendorsLimit] = useState(10);
  const [matchedVendorsPage, setMatchedVendorsPage] = useState(1);
  const [matchedVendorsLimit, setMatchedVendorsLimit] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [showRerunModal, setShowRerunModal] = useState(false);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [unmatchedOptions, setUnmatchedOptions] = useState([
    { label: "Match to Supplier", value: "matchSupplier" },
    { label: "Create Master Supplier", value: "createMasterSupplier" },
    { label: "Rerun Database Match", value: "rerunDatabaseMatch" },
  ]);
  const [matchedOptions, setMatchedOptions] = useState([]);
  const [fullOptions, setFullOptions] = useState([]);
  const [contactsData, setContactsData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [removedCheckedKeys, setRemovedCheckedKeys] = useState([]);
  const [assignMasterNotification, setAssignMasterNotification] =
    useState(false);
  const [selectedKey, setSelectedKey] = useState([]);
  const [showReportDownloadModal, setShowReportDownloadModal] = useState(false);
  const [downloadListData, setDownloadListData] = useState([]);
  const [downloadIndex, setDownloadIndex] = useState();
  const [exportTypeValue, setExportTypeValue] = useState("");

  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === matchedVendorsData.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (
    checkedKeys.length > 0 &&
    checkedKeys.length < matchedVendorsData.length
  ) {
    indeterminate = true;
  }
  const onSetRowLimit = (value) => {
    setLimit(value);
  };

  const handleCheckAll = (value, checked) => {
    let keys = [];
    if (currentTab === "matched") {
      keys = checked ? matchedVendorsData.map((item) => item.id) : [];
    } else if (currentTab === "unmatched") {
      keys = checked ? unmatchedVendorsData.map((item) => item.id) : [];
    }
    setCheckedKeys(keys);
  };

  const handleCheck = (value, checked) => {
    const keys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value);
    setCheckedKeys(keys);
  };

  const handleClickTab = (tab) => {
    tab !== currentTab && setCurrentTab(tab);
    setSearchValue("");
    setCheckedKeys([]);
    setShowContextMenu(false);
    setLimit(10);
  };

  const closeRerunModalHandler = () => {
    setShowRerunModal(false);
  };

  useEffect(() => {
    history.push("/lists/" + selectedCompany?.[0]?.id);
    getListData();
  }, []);

  const handleQaListClick = async () => {
    if (qaListVendors?.length > 0) {
      setShowQaListModal(true);
    } else {
      toast.show({
        title: "Warning",
        description: `No supplier pending for QA!`,
      });
    }
  };

  const handleQaListClose = async (isRefreshData) => {
    setIsRefreshListsData(
      isRefreshListsData ? isRefreshListsData : isRefreshData
    );
    if (isRefreshData) {
      await getTableData(matchedVendorsPage, matchedVendorsLimit, "matched");
      await getQAListVendors(generalInfoData?.id);
    }
    setShowQaListModal(false);
  };

  const handleCloseModal = () => {
    setShowReportDownloadModal(false);
  };

  const handleOpenVendor = async ({ value, offset, limit, index }) => {
    setDownloadIndex(index);
    setShowExportModal(true);
    const company = selectedCompany?.[0];
    let exportData;
    if (value === "supplierMatch") {
      exportData = await getExportListReportData(
        supplierMatchColumns,
        company,
        dispatch,
        value,
        offset,
        limit
      );
      setExportFileName(value + "_" + company?.companyName + "_company");
    } else if (value === "paymentOptimization") {
      exportData = await getExportListReportData(
        paymentOptimizationColumns,
        company,
        dispatch,
        value,
        offset,
        limit
      );
      setExportFileName(value + "_" + company?.companyName + "_company");
    } else if (value === "rwConfiguration") {
      exportData = await getExportListReportData(
        rwConfigurationColumns,
        company,
        dispatch,
        value,
        offset,
        limit
      );
      setExportFileName(value + "_" + company?.companyName + "_company");
    } else if (value === "export") {
      exportData = await getExportListReportData(
        listExportColumns,
        company,
        dispatch,
        value,
        offset,
        limit
      );
      setExportFileName(value + "_" + company?.companyName + "_company");
    }
    setExportData(exportData);
  };

  const handleShowExportModalDetails = async (value) => {

    if (
      value === "supplierMatch" ||
      value === "paymentOptimization" ||
      value === "rwConfiguration" ||
      value === "export"
    ) {
      setSelectedOption(value);
      setShowContextMenu(false);
      const total = await dispatch(getListSupplierCountByListId({ listId: selectedCompany[0]?.id }));
      const chunkSize = 50000;
      if (total?.count <= chunkSize) {
        handleOpenVendor({ value, offset: 0, limit: chunkSize, index: 0 });
      } else {
        const chunks = await getChunkSizes(total, chunkSize, selectedCompany);
        setDownloadListData(chunks);
        setExportTypeValue(value);
        setShowReportDownloadModal(true);
      }
    }
  };

  const handleShowExportModal = async (value) => {
    if (value === "export") {
      let columns = [];
      let tableData = [];
      let exportData = [];
      let fileName = "";
      if (currentTab === "full") {
        fileName = "listVendorsData";
      } else if (currentTab === "unmatched") {
        columns = unmatchedVendorsColumns;
        fileName = "unmatchedVendorsList";
      } else if (currentTab === "matched") {
        columns = [...matchedVendorsColumns];
        columns.push(
          { label: "Matched Address2", name: "matchedAddress2" },
          { label: "Matched City", name: "matchedCity" },
          { label: "Matched State", name: "matchedState" },
          { label: "Matched Zip", name: "matchedZip" },
          { label: "Matched Phone", name: "matchedPhone" },
          { label: "Matched Email", name: "matchedEmail" },
          { label: "Matched Supplier ID", name: "matchedVendorId" }
        );
        fileName = "matchedVendorsList";
      } else if (currentTab === "general") {
        fileName = "listVendorsData";
      }

      if (currentTab === "matched" || currentTab === "unmatched") {
        let matchedSupplierIds = [];
        let matchedSuppliers = [];
        let contacts = [];

        const total = await dispatch(getListSupplierCountByListId({ listId: selectedCompany[0]?.id, type: currentTab }));
        const chunkSize = 50000;
        const company = selectedCompany?.[0];
        if (total?.count <= chunkSize) {
          setDownloadIndex(0);
          setShowExportModal(true);
          setExportFileName(value + "_" + company?.companyName + "_company");
          tableData = await dispatch(
            getListSuppliers({
              listId: selectedCompany?.[0]?.id,
              type: currentTab,
              limit: chunkSize,
              offset: 0,
              sortColumn: "suppliername",
              sortType: "asc",
            })
          ).then((res) => {
            return res?.listSuppliers || [];
          });
          const matchedColumns = [
            "matchedVendorId",
            "matchedVendor",
            "matchedAddress1",
            "matchedAddress2",
            "matchedCity",
            "matchedState",
            "matchedZip",
            "matchedPhone",
            "matchedEmail",
          ];
          exportData = [
            columns.map((column) => {
              return column.label;
            }),
          ];

          if (currentTab === "matched") {
            matchedSupplierIds = tableData?.map((sup) => sup?.matchedSupplierId);
            await dispatch(getSuppliersDataByIds(matchedSupplierIds))
              .then((res) => {
                matchedSuppliers = res;
              })
              .catch((err) => {
                toast.show({
                  title: "Warning",
                  description: `Failed To Get Supplier Data`,
                });
              });
            const phones = matchedSuppliers?.map((data) =>
              data?.phone &&
                !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(
                  data?.phone
                ) &&
                !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(
                  data?.phone
                ) &&
                !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(
                  data?.phone
                ) &&
                /^\d+$/.test(data?.phone)
                ? data?.phone
                : null
            );
            const emails = matchedSuppliers?.map((data) =>
              data?.email && /^\d+$/.test(data?.email) ? data?.email : null
            );
            let contactIds = [];
            let allContactIds = contactIds.concat(phones, emails);
            contactIds = allContactIds?.filter(
              (data) => data && /^\d+$/.test(data)
            );
            const uniqueContactIds = [...new Set(contactIds)];
            if (uniqueContactIds && uniqueContactIds?.length > 0) {
              contacts = await getAllContactsByIds(uniqueContactIds, dispatch);
            }
          } else {
            const phones = tableData?.map((data) =>
              data?.phone &&
                !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(
                  data?.phone
                ) &&
                !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(
                  data?.phone
                ) &&
                !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(
                  data?.phone
                ) &&
                /^\d+$/.test(data?.phone)
                ? data?.phone
                : null
            );
            const emails = tableData?.map((data) =>
              data?.email && /^\d+$/.test(data?.email) ? data?.email : null
            );
            let contactIds = [];
            let allContactIds = contactIds.concat(phones, emails);
            contactIds = allContactIds?.filter(
              (data) => data && /^\d+$/.test(data)
            );
            const uniqueContactIds = [...new Set(contactIds)];
            if (uniqueContactIds && uniqueContactIds?.length > 0) {
              contacts = await getAllContactsByIds(uniqueContactIds, dispatch);
            }
          }
          exportData.push(
            ...tableData.map((row) => {
              let supplier;
              if (currentTab === "matched") {
                supplier = matchedSuppliers.find(
                  (sup) => sup?.id === row?.matchedSupplierId
                );
              }
              return columns.map((column) => {
                if (
                  column.name === "qaStatus" &&
                  row.hasOwnProperty("approvedByManager")
                ) {
                  let status =
                    row["approvedByManager"] === true
                      ? "Approved"
                      : row["approvedByManager"] === false
                        ? "Rejected"
                        : "Pending";
                  row[column.name] = status;
                }
                if (
                  currentTab === "matched" &&
                  matchedColumns.includes(column.name)
                ) {
                  row[column.name] = getListMatchedVendorData(
                    column.name,
                    supplier,
                    contacts
                  );
                }
                if (column.name === "phone") {
                  row[column.name] = getContactPhoneValue(row?.phone, contacts);
                }
                if (column.name === "email") {
                  row[column.name] = getContactEmailValue(row?.email, contacts);
                }
                if (row[column.name] && typeof row[column.name] === "string") {
                  return row[column.name]
                    .replaceAll(",", " ")
                    .replaceAll("#", "");
                } else {
                  return row[column.name];
                }
              });
            })
          );
        } else {
          const chunks = await getChunkSizes(total, chunkSize, selectedCompany);
          setDownloadListData(chunks);
          setExportTypeValue(value);
          setShowReportDownloadModal(true);
          setExportFileName(value + "_" + company?.companyName + "_company");
        }
      } else {
        handleShowExportModalDetails(value);
      }

      setExportData(exportData);
    } else {
      handleShowExportModalDetails(value);
    }
    setIsOpen(false);
  };

  const handleCloseExportModal = async (status = false) => {
    if (status) {
      if (downloadListData[downloadIndex]) {
        const updatedList = [...downloadListData];
        updatedList[downloadIndex] = {
          ...updatedList[downloadIndex],
          isDownloaded: true,
        };
        setDownloadListData(updatedList);
      }
    }
    setShowExportModal(false);
    setExportData([]);
    setExportFileName("");
  };

  // get context menu element
  var element;
  const handleModalShow = () => {
    let context = document.getElementById("list-info-modal");
    element = context.getElementsByClassName("rs-modal-body");
  };

  const handleMenuItemClick = async (value) => {
    setShowContextMenu(false);
    if (selectedVendor?.matchStatus === "Sent To Auto Create Master") {
      setShowConfirmationModal(true);
    } else {
      if (value.value === "createMasterSupplier") {
        setShowCreateMasterModal(true);
      } else if (value.value === "matchSupplier") {
        setShowSearchOptions(true);
      } else if (value.value === "rerunDatabaseMatch") {
        setShowRerunModal(true);
      } else if (value.value === "delete") {
        setDeleteModal(true);
      }
    }
  };

  useEffect(() => {
    if (currentTab !== "general" && currentTab !== "matched") {
      let context = document.getElementById("list-info-modal");
      if (context) {
        element = context.querySelector(
          currentTab === "full"
            ? "#full-vendors-table"
            : currentTab === "unmatched"
              ? "#unmatched-vendors-table"
              : "#matched-vendors-table"
        );
      }
      if (element) {
        setContextMenuElement(element);
        element.oncontextmenu = async function (e) {
          e.preventDefault();
          let parentWithClass = "";
          if (currentTab === "full") {
            parentWithClass = e.target.closest(
              ".rs-table-row .full-vendors-table-cell"
            );
          } else if (currentTab === "unmatched") {
            parentWithClass = e.target.closest(
              ".rs-table-row .unmatched-vendors-table-cell"
            );
          } else if (currentTab === "matched") {
            parentWithClass = e.target.closest(
              ".rs-table-row .matched-vendors-table-cell"
            );
          }
          const rowId = parseInt(parentWithClass?.id);
          const rowData =
            currentTab === "full"
              ? fullVendorList.find((vendor) => vendor?.id === rowId)
              : currentTab === "unmatched"
                ? unmatchedVendorsData.find((vendor) => vendor?.id === rowId)
                : matchedVendorsData.find((vendor) => vendor?.id === rowId);
          if (
            rowData?.isInCalls === null &&
            isAdminOrModerator &&
            !rowData?.matchedSupplierId
          ) {
            let tmp = [];
            if (currentTab === "full") {
              const isExist = fullOptions.find(
                (option) => option.value === "delete"
              );
              if (!isExist?.value) {
                tmp = [...fullOptions, { value: "delete", label: "Delete" }];
                setFullOptions(tmp);
              }
            } else if (currentTab === "unmatched") {
              const isExist = unmatchedOptions.find(
                (option) => option.value === "delete"
              );
              if (!isExist?.value) {
                tmp = [
                  ...unmatchedOptions,
                  { value: "delete", label: "Delete" },
                ];
                setUnmatchedOptions(tmp);
              }
            }
          } else {
            setFullOptions([]);
            setUnmatchedOptions(
              unmatchedOptions?.filter((data) => data?.value !== "delete")
            );
          }
          setSelectedVendor(rowData);
          setShowContextMenu(true);
        };
      }
    }
  }, [currentTab, unmatchedVendorsData, matchedVendorsData, fullVendorList]);

  const getListData = async () => {
    setIsLoadingListData(true);
    await dispatch(getListDataById(selectedCompany?.[0]?.id))
      .then(async (res) => {
        await getQAListVendors(res?.list?.id);
        setGeneralInfoData(res?.list);
        setIsLoadingListData(false);
      })
      .catch(() => {
        setIsLoadingListData(false);
      });
  };

  const handleConfirmClick = async (
    id,
    matchedSupplierId,
    status,
    listId = null,
    masterSupplierId = null
  ) => {
    if (id && !Array.isArray(id)) {
      id = [id];
    }
    setIsLoading(true);
    if (!id || id?.length === 0) {
      toast.show({
        title: "Error",
        description: "No List Supplier Id Found",
      });
      return;
    }
    dispatch(
      matchListSupplierToSupplier({
        id,
        matchedSupplierId,
        status: status ? status : "Manually Matched Master",
      })
    )
      .then(async () => {
        setIsLoading(false);
        toast.show({
          title: "Success",
          description: "Successfully matched list supplier!",
        });
        await getTableData(
          unmatchedVendorsPage,
          unmatchedVendorsLimit,
          "unmatched",
          "",
          "suppliername",
          "asc"
        );
        setCheckedKeys([]);
        setShowSearchOptions(false);
        setShowCreateMasterModal(false);
        setIsRefreshListsData(true);
      })
      .catch(() => {
        setIsLoading(false);
        setShowCreateMasterModal(false);
        toast.show({
          title: "Error",
          description: "Failed to match list supplier!",
        });
      });

    if (id?.length > 0) {
      for (let index = 0; index < id?.length; index++) {
        dispatch(
          createChildForListSupplier(
            id[index],
            matchedSupplierId,
            generalInfoData?.domainId,
            generalInfoData?.userId,
            listId,
            masterSupplierId ? masterSupplierId : matchedSupplierId
          )
        )
          .then((res) => {
            toast.show({
              title: "Success",
              description: "Child supplier created successfully!",
            });
          })
          .catch((err) => {
            toast.show({
              title: "Warning",
              description: "Failed to create child supplier!",
            });
          });
      }
    }
  };

  const getTableData = async (
    page,
    limit,
    type,
    search = "",
    sortColumn = "suppliername",
    sortType = "asc"
  ) => {
    setIsLoadingListData(true);
    setUnmatchedVendorPage(page);
    setFullVendorPage(page);
    setMatchedVendorPage(page);
    await dispatch(
      getListSuppliers({
        listId: selectedCompany?.[0]?.id,
        type: type,
        limit: limit,
        offset: limit * (page - 1),
        search,
        sortColumn,
        sortType,
      })
    )
      .then(async (res) => {
        if (type === "full") {
          setTotalFullVendors(res?.totalListSuppliers || 0);
          setFullVendorList(res?.listSuppliers || []);
        } else if (type === "matched") {
          setMatchedVendorsPage(page);
          setMatchedVendorsLimit(limit);
          setTotalMatchedVendors(res?.totalListSuppliers || 0);
          setMatchedVendorsData(res?.listSuppliers || []);
        } else if (type === "unmatched") {
          setContactsData(res?.contacts || []);
          setUnmatchedVendorsPage(page);
          setUnmatchedVendorsLimit(limit);
          setTotalUnmatchedVendors(res?.totalListSuppliers || 0);
          setUnmatchedVendorsData(res?.listSuppliers || []);
        }
        setIsLoadingListData(false);
      })
      .catch(() => {
        setIsLoadingListData(false);
      });
  };

  const getQAListVendors = async (listId) => {
    await dispatch(getQaListVendorsByListId(listId))
      .then((listSups) => {
        setQaListVendors(listSups?.qaVendors);
      })
      .catch(() => {
        setQaListVendors([]);
      });
  };

  const supplierNameSearchHandler = (e) => {
    setSearchValue(e.target.value);
  };

  const handleCreateMastersClick = async () => {
    setShowCreateMastersModal(true);
  };

  const handleCreateMastersCloseClick = async (isGetUnmatchedData) => {
    setShowCreateMastersModal(false);
    if (isGetUnmatchedData) {
      await getTableData(1, 10, "unmatched", "", "suppliername", "asc");
    }
  };

  const handleCreateMaster = (isRefresh) => {
    setIsRefreshListsData(isRefresh);
  };

  const handleRemoveMatchedSuppliers = async () => {
    await dispatch(removeMatchedSupplierForListSupplier(checkedKeys))
      .then(async (res) => {
        setCheckedKeys([]);
        setShowModal(false);
        await getTableData(1, 10, "matched", "", "suppliername", "asc");
        toast.show({
          title: "Success",
          description: "Removed Matched Supplier Successfully",
        });
      })
      .catch((err) => {
        toast.show({
          title: "Warning",
          description: "Failed To Removed Matched Supplier",
        });
      });
  };

  const onDeleteHandler = async () => {
    setIsDeleting(true);
    await dispatch(deleteListSupplier(selectedVendor?.id))
      .then(async () => {
        setDeleteModal(false);
        toast.show({
          title: "Success",
          description: "List Supplier deleted successfully",
        });
        setIsDeleting(false);
        setIsRefreshListsData(true);
        await getTableData(
          1,
          10,
          currentTab === "full"
            ? "full"
            : currentTab === "unmatched"
              ? "unmatched"
              : "matched",
          "",
          "suppliername",
          "asc"
        );
        currentTab === "full"
          ? setFullVendorPage(1)
          : currentTab === "unmatched"
            ? setUnmatchedVendorPage(1)
            : setMatchedVendorPage(1);
      })
      .catch(() => {
        setIsDeleting(false);
        toast.show({
          title: "Warning",
          description: "Unable to delete the list supplier",
        });
      });
  };

  const onSelectedListSuppliers = (type) => {
    setSelectedKey([...checkedKeys]);
    if (checkedKeys && checkedKeys?.length === 0) {
      toast.show({
        title: "Warning",
        description: "Please select list suppliers!",
      });
      return;
    }
    const toRemove = [];
    const toKeep = [];
    checkedKeys.forEach((id) => {
      const row = selectedRows.find((item) => item.id === id);
      if (row?.matchStatus === "Sent To Auto Create Master") {
        toRemove.push(id);
      } else {
        toKeep.push(id);
      }
    });
    setCheckedKeys(toKeep);
    setRemovedCheckedKeys(toRemove);
    if (toRemove.length > 0) {
      setAssignMasterNotification(true);
      setShowConfirmationModal(true);
    } else {
      setAssignMasterNotification(false);
    }
    type === "delete"
      ? setDeleteModal(true)
      : type === "remove"
        ? setShowModal(true)
        : setShowSearchModal(true);
  };

  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => {
    if (!isLoadingListData) {
      setIsOpen(!isOpen);
    }
    if (currentTab === "matched" || currentTab === "unmatched") {
      handleShowExportModal("export");
    }
  };
  const dropdownMenuStyle = {
    position: "absolute",
    top: "100%",
    right: "0",
    zIndex: 1000,
    minWidth: "220px",
    padding: "0.5rem 0",
    marginTop: "0.5rem",
    fontSize: "1rem",
    color: "#212529",
    backgroundColor: "#ffffff",
    border: "none",
    borderRadius: "0.75rem",
    boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.1)",
    opacity: isOpen ? 1 : 0,
    transition: "all 0.2s ease-in-out",
    pointerEvents: isOpen ? "auto" : "none",
  };

  const dropdownItemStyle = {
    fontWeight: 500,
    padding: "10px 20px",
    width: "100%",
    textAlign: "left",
    background: "none",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
  };
  return (
    <>
      <Modal
        show={showConfirmationModal}
        onHide={() => {
          setShowConfirmationModal(false);
        }}
        style={{ zIndex: 1060 }}
      >
        <Modal.Header>
          {!assignMasterNotification ? (
            <h2 className="mb-0">
              {selectedVendor?.suppliername} is already sent to Create Auto
              Master
            </h2>
          ) : (
            <h2 className="mb-0">
              {removedCheckedKeys.length} of {selectedKey.length} already sent
              to Create Auto Master
            </h2>
          )}
          <div className="mt-4">
            <button
              className="me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded btn-green text-white ms-auto float-end width-100"
              onClick={() => {
                setShowConfirmationModal(false);
              }}
            >
              Ok
            </button>
          </div>
        </Modal.Header>
      </Modal>

      {deleteModal && (
        <ModalComponent
          backdrop={"static"}
          open={deleteModal}
          handleClose={() => {
            setDeleteModal(false);
          }}
          modalTitle={`Do you want to delete list supplier permanently?`}
          size={`md`}
        >
          <div
            className={`d-flex column-gap-3${isDeleting ? " position-relative loading" : ""
              }`}
          >
            {isDeleting && <LoaderComponent />}
            <button
              disabled={isDeleting}
              onClick={() => {
                setDeleteModal(false);
              }}
              className="report_small_button_grey"
            >
              Cancel
            </button>
            <button
              disabled={isDeleting}
              onClick={() => {
                onDeleteHandler();
              }}
              className="report_small_button_danger"
            >
              Delete
            </button>
          </div>
        </ModalComponent>
      )}
      <Modal
        backdrop="static"
        className="list-info-modal"
        style={{ paddingLeft: 50, paddingRight: 50 }}
        id="list-info-modal"
        show={show}
        size="xl"
        onClick={() => {
          onClose(isRefreshListsData);
        }}
        onHide={() => {
          onClose(isRefreshListsData);
        }}
        onExited={() => {
          handleModalShow();
        }}
      >
        <Modal.Header></Modal.Header>
        <Modal.Body
          className={`m-5  position-relative${isLoadingListData ? " loading" : ""
            }`}
        >
          {isLoadingListData && <LoaderComponent />}
          <div
            className={` mb-4 align-items-center d-flex ${currentTab === "general"
              ? "justify-content-end"
              : "justify-content-between"
              }`}
          >
            {currentTab !== "general" && (
              <div className="d-flex w-50 gap-4 align-items-center ">
                <input
                  type="text"
                  className=" search-input w-50 shadow-none h5 mb-0 "
                  placeholder="Supplier Name"
                  onChange={(event) => supplierNameSearchHandler(event)}
                  value={searchValue}
                  disabled={isLoadingListData}
                />
                <div className="jh-75 d-flex align-items-center w-50 gap-4">
                  <button
                    className="pt-3 pb-3 p-5 w-50 h-1d00 bg-green border-0 rounded text-white h4 mb-0"
                    onClick={(e) => {
                      getTableData(
                        1,
                        limit,
                        currentTab,
                        searchValue,
                        "suppliername",
                        "asc"
                      );
                    }}
                    disabled={isLoadingListData}
                  >
                    Search
                  </button>
                  <button
                    className="pt-3 pb-3 p-5 w-50 h-10d0 bg-gray border-0 rounded text-white h4 mb-0"
                    onClick={(e) => {
                      getTableData(
                        1,
                        limit,
                        currentTab,
                        "",
                        "suppliername",
                        "asc"
                      );
                      setSearchValue("");
                    }}
                    disabled={isLoadingListData}
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}
            <div className=" d-flex w-50 gap-4 align-items-center justify-content-end h-100">
              {currentTab === "matched" && (
                <button
                  className=" p-3 h-75 rounded h4 mb-0 bg-red text-white"
                  onClick={() => {
                    onSelectedListSuppliers("remove");
                  }}
                >
                  Remove Matched Supplier
                </button>
              )}

              {currentTab === "matched" && (
                <button
                  className="pt-3 pb-3 p-5 h-75 rounded h4 mb-0 bg-blue text-white"
                  onClick={handleQaListClick}
                  disabled={isLoadingListData || !qaListVendors?.length}
                >
                  QA List
                </button>
              )}
              {currentTab === "unmatched" && (
                <button
                  className="pt-3 pb-3 p-5 h-75 rounded h4 mb-0 bg-gray text-white"
                  onClick={() => {
                    onSelectedListSuppliers("assign");
                  }}
                >
                  Assign Master
                </button>
              )}
              {currentTab === "unmatched" && (
                <button
                  className="pt-3 pb-3 p-5 h-75 rounded h4 mb-0 bg-gray text-white"
                  onClick={handleCreateMastersClick}
                  disabled={isLoadingListData}
                >
                  Create Masters
                </button>
              )}
              {/* <button className='pt-3 pb-3 p-5 h-75 rounded h4 mb-0 bg-green text-white' onClick={handleShowExportModal} disabled={isLoadingListData}>Export</button> */}
              <div className="dropdown" style={{ position: "relative", display: "inline-block" }}>
                <button className="pt-3 pb-3 p-5 h-75 rounded h4 mb-0 bg-green text-white dropdown-toggle dropdown-menu-right" type="button" onClick={() => toggleDropdown()} disabled={isLoadingListData}>
                  Export
                </button>

                <div style={dropdownMenuStyle}>
                  {currentTab !== "matched" && currentTab !== "unmatched" ? (
                    <button style={dropdownItemStyle} onClick={() => handleShowExportModal("supplierMatch")}>
                      Supplier Match Preview
                    </button>
                  ) : null}

                  {currentTab !== "matched" && currentTab !== "unmatched" ? (
                    <button style={dropdownItemStyle} onClick={() => handleShowExportModal("paymentOptimization")}>
                      Payment Optimization Report
                    </button>
                  ) : null}

                  {currentTab !== "matched" && currentTab !== "unmatched" ? (
                    <button style={dropdownItemStyle} onClick={() => handleShowExportModal("rwConfiguration")}>
                      RW Configuration Report
                    </button>
                  ) : null}

                  {currentTab !== "matched" && currentTab !== "unmatched" ? (
                    <button style={dropdownItemStyle} onClick={() => handleShowExportModal("export")}>
                      Legacy Results Report
                    </button>
                  ) : null}
                </div>
              </div>

            </div>
          </div>
          <div className="list-tabs d-flex align-items-end border border-top-0 border-start-0 border-end-0 border-2">
            {tabs.map((tab) => (
              <button
                key={tab.value}
                type="button"
                className={`h4 mb-0 page-tab bg-gray list-tab pt-2 pb-2 p-4 text-white me-3${currentTab === tab.value ? " selected bg-blue pt-3 pb-3" : ""
                  }`}
                onClick={() => {
                  handleClickTab(tab.value);
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
          {currentTab === "general" && (
            <GeneralInformation
              generalInfoData={generalInfoData}
              listTableColumns={listTableColumns}
              totalApSpend={selectedCompany?.[0]?.totalApSpend || 0}
            />
          )}
          {currentTab === "full" && (
            <FullVendorList
              tabledata={fullVendorList}
              total={totalFullVendors}
              vendorListColumns={vendorListColumns}
              listId={selectedCompany?.[0]?.id}
              onGetTableData={getTableData}
              currentTab={currentTab}
              searchValue={searchValue}
              checkedKeys={checkedKeys}
              setCheckedKeys={setCheckedKeys}
              fullVendorPage={fullVendorPage}
              setFullVendorPage={setFullVendorPage}
              onSetRowLimit={onSetRowLimit}
            />
          )}
          <div className="unmatched-vendor-list">
            {currentTab === "unmatched" && (
              <UnmatchedVendors
                tabledata={unmatchedVendorsData}
                total={totalUnmatchedVendors}
                unmatchedVendorsColumns={unmatchedVendorsColumns}
                showContextMenu={showContextMenu}
                onMenuItemClick={handleMenuItemClick}
                listId={selectedCompany?.[0]?.id}
                onGetTableData={getTableData}
                showCreateMasterModal={showCreateMasterModal}
                setShowCreateMasterModal={setShowCreateMasterModal}
                currentTab={currentTab}
                searchValue={searchValue}
                handleCheckAll={handleCheckAll}
                handleCheck={handleCheck}
                checkedKeys={checkedKeys}
                setCheckedKeys={setCheckedKeys}
                unmatchedVendorPage={unmatchedVendorPage}
                setUnmatchedVendorPage={setUnmatchedVendorPage}
                contactsData={contactsData}
                onSetRowLimit={onSetRowLimit}
                setSelectedRows={setSelectedRows}
              />
            )}
          </div>
          {currentTab === "matched" && (
            <MatchedVendors
              tabledata={matchedVendorsData}
              total={totalMatchedVendors}
              matchedVendorsColumns={matchedVendorsColumns}
              selectedCompany={generalInfoData}
              listId={selectedCompany?.[0]?.id}
              onGetTableData={getTableData}
              currentTab={currentTab}
              searchValue={searchValue}
              handleCheckAll={handleCheckAll}
              handleCheck={handleCheck}
              checkedKeys={checkedKeys}
              setCheckedKeys={setCheckedKeys}
              handleRemoveMatchedSuppliers={handleRemoveMatchedSuppliers}
              matchedVendorPage={matchedVendorPage}
              setMatchedVendorPage={setMatchedVendorPage}
              onSetRowLimit={onSetRowLimit}
            />
          )}
        </Modal.Body>
        <Modal.Footer className="pe-3"></Modal.Footer>
        {showContextMenu && (
          <ContextMenu
            menuItems={
              currentTab === "full"
                ? fullOptions
                : currentTab === "unmatched"
                  ? unmatchedOptions
                  : matchedOptions
            }
            onMenuItemClick={handleMenuItemClick}
            onMenuItemBlur={() => {
              setShowContextMenu(false);
            }}
            element={contextMenuElement}
          />
        )}
      </Modal>
      {showModal && (
        <ModalComponent
          size="md"
          modalTitle="Do you want to remove the matched supplier for the selected list supplier?"
          open={showModal}
          handleClose={() => {
            setShowModal(false);
          }}
        >
          <div className="d-flex column-gap-3">
            <button
              className="report_small_button_grey"
              onClick={() => {
                setShowModal(false);
              }}
            >
              Cancel
            </button>
            <button
              className="report_small_button_danger"
              onClick={handleRemoveMatchedSuppliers}
            >
              Remove
            </button>
          </div>
        </ModalComponent>
      )}
      {showQaListModal && (
        <QAList
          show={showQaListModal}
          onGoBack={handleQaListClose}
          allVendors={qaListVendors}
          page="list"
        />
      )}
      {showExportModal && (
        <VendorExportModal
          show={showExportModal}
          exportData={exportData}
          onClose={(status) => handleCloseExportModal(status)}
          fileName={exportFileName}
        />
      )}
      {showCreateMasterModal && (
        <Modal
          backdrop="static"
          className="create-supplier-modal my-5 px-5"
          show={showCreateMasterModal}
          size="xl"
          onClick={() => {
            setShowCreateMasterModal(false);
          }}
          onHide={() => {
            setShowCreateMasterModal(false);
          }}
        >
          <Modal.Header></Modal.Header>
          <Modal.Body>
            <CreateMasterModal
              isFromList={true}
              listSupplier={selectedVendor}
              onClose={() => {
                setShowCreateMasterModal(false);
                setShowRerunModal(false);
              }}
              onUpdateListSupplier={handleConfirmClick}
              isCreatingMasterFromList={isLoading}
              setShowCreateMasterModal={setShowCreateMasterModal}
              contactsData={contactsData}
            />
          </Modal.Body>
        </Modal>
      )}

      {(showSearchOptions || showSearchModal) && (
        <SearchModal
          show={(showSearchOptions || showSearchModal) && true}
          onGoBack={() => {
            showSearchModal
              ? setShowSearchModal(false)
              : setShowSearchOptions(false);
          }}
          selectedVendor={showSearchModal ? checkedKeys : selectedVendor}
          onConfirm={handleConfirmClick}
          isLoading={isLoading}
          showCreateMasterModal={showCreateMasterModal}
          setShowCreateMasterModal={setShowCreateMasterModal}
          setSelectedVendor={setSelectedVendor}
          showSearchModal={showSearchModal}
          contactsData={contactsData}
        />
      )}
      {showCreateMastersModal && (
        <CreateMastersModal
          show={showCreateMastersModal}
          listId={selectedCompany?.[0]?.id}
          columns={createMastersColumns}
          handleClose={handleCreateMastersCloseClick}
          onCreateMaster={handleCreateMaster}
          generalInfoData={generalInfoData}
        />
      )}
      {showRerunModal && (
        <RerunModal
          show={showRerunModal}
          // showCreateMasterModal={showCreateMasterModal}
          setShowCreateMasterModal={setShowCreateMasterModal}
          selectedVendor={selectedVendor}
          closeRerunModalHandler={closeRerunModalHandler}
          getTableData={getTableData}
        />
      )}
      {showReportDownloadModal && (
        <ReportDownloadModal
          value={exportTypeValue}
          showReportDownloadModal={showReportDownloadModal}
          handleCloseModal={handleCloseModal}
          selectedOption={selectedOption}
          downloadListData={downloadListData}
          handleOpenVendor={handleOpenVendor}
        />
      )}
    </>
  );
};
export default ListInfoModal;
